import React from "react";
import { FaLinkedin, FaTwitter, FaGithub, FaEnvelope } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";
import Salutations from "./Salutations";
import SkillGlobe from "./SkillGlobe";
import "../assets/css/fonts.css";

function Hero() {
  const { t } = useLanguage();

  return (
    <section className="hero-section" id="hero">
      <div className="hero-container">
        <div
          className="hero-text"
          style={{
            textAlign: "right",
          }}
        >
          <h1>
            <span className="greeting">{t("heroGreeting")}</span>
            <span
              className="name-accent"
              style={{
                textAlign: "right",
                fontFamily: "matura",
              }}
            >
              Ahmada☕
            </span>
          </h1>
          <Salutations />
          <div
            className="hero-social"
            style={{
              textAlign: "right",
              float: "right",
              alignItems: "right",
            }}
          >
            <a
              href="https://www.linkedin.com/in/amadou-ngom-8b0103157/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://x.com/_ameahmada_"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://github.com/ameahmada"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGithub />
            </a>
            <a href="mailto:contact@ahmada.dev">
              <FaEnvelope />
            </a>
          </div>
        </div>
        <div className="hero-image">
          <SkillGlobe />
        </div>
      </div>
    </section>
  );
}

export default Hero;
